<template>
  <div class="c-base-input-outlined">
    <label
      v-if="label"
      :for="id"
      :class="statusClasses"
      class="c-label"
      v-html="label"
    ></label>
    <input
      v-if="format"
      @input="$emit('input', $event.target.value)"
      :id="id"
      v-mask="format"
      :class="statusClasses"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :autocomplete="autocomplete ? 'on' : 'off'"
      :maxlength="maxlength"
      class="c-input"
    />
    <input
      v-else
      @input="$emit('input', $event.target.value)"
      :id="id"
      :class="statusClasses"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :autocomplete="autocomplete ? 'on' : 'off'"
      :maxlength="maxlength"
      class="c-input"
    />

    <div class="c-box-bottom">
      <p class="c-label-bottom c-error">
        {{ error }}
      </p>
      <p
        v-if="maxlength > 0"
        class="c-label-bottom c-character-count"
        :class="{ 'c-error': value?.length >= maxlength }"
      >
        Caracteres: {{ value?.length || 0 }}/{{ maxlength }}
      </p>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },

  props: {
    id: {
      type: String,
      default: `input-${Math.random()}`,
    },
    value: {
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
    },
    hasSuccess: {
      type: Boolean,
    },
    hasError: {
      type: Boolean,
    },
    error: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '',
    },
  },

  computed: {
    statusClasses() {
      return {
        'is-error': this.hasError,
        'is-success': this.hasSuccess,
      }
    },
  },
}
</script>

<style lang="scss">
.c-base-input-outlined {
  .c-label {
    display: block;
    align-items: center;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: normal;
    color: $neutral;
    line-height: 20px;
    > strong {
      font-weight: bold;
      color: inherit;
    }
    &.is-error {
      color: $error;
    }
    &.is-success {
      color: $tertiary;
    }
  }

  .c-input {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    font-size: 16px;
    color: $neutral;
    border-radius: 8px;
    border: 1px solid rgba($neutrallight, 0.5);
    &::placeholder {
      color: rgba($neutral, 0.5);
    }
    &:hover {
      border-color: $neutrallight;
    }
    &:focus,
    &:active {
      border-color: $neutrallight;
      box-shadow: 0px 0px 3px 0px $neutrallight;
      outline: none;
    }
    &.is-success {
      border-color: $tertiary;
      box-shadow: none;
    }
    &.is-error {
      border-color: $error;
      box-shadow: none;
    }
    &:disabled {
      color: #cbcbcb;
      cursor: not-allowed;
      pointer-events: none;
      border-color: #f3f3f3;
      background-color: #f3f3f3;
      opacity: 1;
    }
  }

  .c-box-bottom {
    display: flex;
    justify-content: space-between;
  }

  .c-label-bottom {
    margin-top: 2px;
    font-size: 12px;
    line-height: 15.6px;
  }

  .c-character-count {
    min-width: 110px;
    margin-left: 8px;
    text-align: right;
  }

  .c-error {
    color: $error;
  }
}
</style>
